/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { withRouter } from "react-router-dom";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { vehicleWiseCollectionListAction } from "../../../redux/action-creators/collectionActionCreator";

class OperatorViewVehicleList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,
      rowsPerPage: 10,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      selected: [],
      sortBy: "",
    };
    this.operatorViewGetList = this.operatorViewGetList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.handleColumnAction = this.handleColumnAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.operatorViewGetList();
  }

  componentDidUpdate(prevProps) {
    const {
      searchString, cityFilter, operatorFilter, selectedDateFilter, selectedOperation,
    } = this.props;
    if (
      (prevProps && prevProps.searchString !== searchString)
      || (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
      || (prevProps && prevProps.selectedOperation !== selectedOperation)
    ) {
      this.operatorViewGetList();
    }
  }

  handleAction(vehicleDetails) {
    const { history } = this.props;
    history.push("/collection-view/details", vehicleDetails);
  }

  handleColumnAction(vehicleDetails, column) {
    const { history } = this.props;
    if (column === "walletUsage") {
      history.push("/collection-view/balance-spent", vehicleDetails);
    } else {
      history.push("/collection-view/balance-loaded", vehicleDetails);
    }
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.operatorViewGetList();
      },
    );
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.operatorViewGetList();
      }
    });
  };

  /**
   * API call to get devices.
   * @param pageNo current page number
   */
  operatorViewGetList() {
    const {
      fetchCollection, searchString, operatorFilter,
      selectedOperation, cityFilter, selectedDateFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchCollection({
      pageNo,
      pageSize: rowsPerPage,
      searchString,
      operatorFilter,
      operationType: selectedOperation,
      cityFilter,
      dateFilter: selectedDateFilter,
      sortBy,
    });
  }

  render() {
    const {
      headerLoader, content, totalItems, user,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    let templateString = templateStrings.operatorViewVehicleWise;
    if (user && user.role && user.role === "AgencyManager") {
      templateString = templateStrings.agencyViewVehicleWise;
    }
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="busNumber"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateString}
          selectionAllowed={false}
          handleAction={this.handleAction}
          handleColumnAction={this.handleColumnAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Collection
        && state.Collection.vehicleWiseCollection
        && state.Collection.vehicleWiseCollection.data)
      || [],
    totalItems:
      (state
        && state.Collection
        && state.Collection.vehicleWiseCollection
        && state.Collection.vehicleWiseCollection.totalItems)
      || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    user: state.Auth.user,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchCollection: (params) => {
    dispatch(vehicleWiseCollectionListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OperatorViewVehicleList));
